const theme = {
    /* COLORS */
    // primaryColor: "#f36f32",
    // primaryColor: "#192a56",
    // primaryColor: "#ffa801",
    // primaryColor: "#3499b2",
    primaryColor: "#0356C4",
    // secondaryColor: "#ffde34",
    secondaryColor: "#FECC45",
    //warningColor: "#fed330",
    warningColor: "#ffa700",
    errorColor: "#e74d4d",
    successColor: "#27ae60",
    fontColor: '#3d3d3d',
    backgroundColor: '#f0f0f7',
    appDrawerBgColor: "#43425d",
    appDrawerActiveLinkColor: "#fecc45",
    secondaryBackgroundColor: "#ffffff",
    borderColor: "rgba(0, 0, 0, 0.23)",
    smBorderColor: "rgba(0, 0, 0, 0.1)",
    
    /* FONTS */
    fontSize: '1rem',
    fontFamily: "'Poppins', sans-serif",
    navHeight: 48,
    
    /* GRIDS */
    smWidth: "961px",
    mdWidth: "1281px",
    
    /* BOX SHADOW */
    boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
    smBoxShadow: "0px 1px 2px -0.5px rgba(0,0,0,0.2), 0px 2px 2.5px 0px rgba(0,0,0,0.14), 0px 0.5px 5px 0px rgba(0,0,0,0.12)",
    
    /* BORDER RADIUS */
    borderRadius: "5px",
    smBorderRadius: "3px",
    lgBorderRadius: "8px"
}

export default theme